
import React from 'react';
import { VendorProfile, SystemConfig } from '../types';

interface UpgradeModalProps {
  vendor: VendorProfile;
  systemConfig: SystemConfig;
  onClose: () => void;
}

const UpgradeModal: React.FC<UpgradeModalProps> = ({ vendor, systemConfig, onClose }) => {
  const handleUpgradeContact = () => {
    const text = `Olá! Gostaria de migrar minha loja "${vendor.name}" para o Plano PRO no Compre em Guarulhos.`;
    window.open(`https://wa.me/${systemConfig.supportWhatsapp}?text=${encodeURIComponent(text)}`, '_blank');
  };

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-navy/90 backdrop-blur-sm" onClick={onClose} />
      
      <div className="relative bg-navy w-full max-w-md max-h-[90vh] rounded-[3rem] border border-white/10 shadow-2xl overflow-y-auto animate-in zoom-in duration-300 no-scrollbar">
        <div className="p-8 text-center flex flex-col items-center">
          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-brand-orange/10 rounded-full flex items-center justify-center mb-6 flex-shrink-0">
            <svg className="w-8 h-8 sm:w-10 sm:h-10 text-brand-orange" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          
          <h2 className="text-2xl sm:text-3xl font-title font-bold text-white mb-4 leading-tight uppercase tracking-tighter italic">
            Limite atingido no <span className="text-brand-orange">Plano Grátis!</span>
          </h2>
          
          <p className="text-blue-100/70 mb-8 leading-relaxed text-sm">
            Seja um <span className="text-white font-bold">Parceiro PRO</span> para cadastrar ofertas ilimitadas e ganhar o <span className="text-brand-orange font-bold italic uppercase">Selo Verificado</span>.
          </p>
          
          <button 
            onClick={handleUpgradeContact}
            className="w-full bg-brand-orange text-white font-title font-black py-5 rounded-2xl shadow-xl hover:scale-[1.02] transition-all mb-4 text-xs uppercase tracking-widest"
          >
            Ativar Plano PRO agora
          </button>
          
          <button onClick={onClose} className="text-white/40 text-[10px] font-black uppercase tracking-widest hover:text-white transition-colors py-2">
            Voltar depois
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
